<template>

  <v-toolbar dense flat >
    <v-toolbar-title v-text="title" class="mr-2" />
    <v-btn small
      v-for="space in spaces"
      @click="selectedSpace = space"
      color="primary" class="mx-1"
      :outlined="selectedSpaceId !== space.id"
      :key="space.id" >
        {{space.title}}
    </v-btn>

    <template slot="extension" v-if="practitionerSelectable" >
      <v-btn small
        v-for="practitioner in members"
        @click="selectedPractitioner = practitioner"
        color="primary" class="mx-1"
        :outlined="selectedPractitionerId !== practitioner.id"
        :key="practitioner.id" >
          {{practitioner.full_name}}
      </v-btn>
    </template>
  </v-toolbar>

</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ManageToolbar',
  props: {
    title: { type: String },
    businessId: { required: true },
    spaceId: { required: false },
    space: { type: Object, required: false },
    practitionerId: { required: false },
    practitioner: { type: Object, required: false },
    practitionerSelectable: { type: Boolean, default: true },
    spaceSelectable: { type: Boolean, default: true }
  },
  data () {
    return {
      selectedSpace: {},
      selectedPractitioner: {}
    }
  },
  watch: {
    space: {
      immediate: true,
      handler () {
        if (this.space && this.space.id) { this.selectedSpace = this.space }
      }
    },
    selectedSpaceId () {
      this.$emit('update:spaceId', this.selectedSpaceId)
      this.$emit('update:space', this.selectedSpace)
      if (this.practitionerId) {
        this.selectedPractitioner = this.getPractitionerById(this.practitionerId)
      }
    },
    selectedPractitionerId () {
      this.$emit('update:practitionerId', this.selectedPractitionerId)
      this.$emit('update:practitioner', this.selectedPractitioner)
    },
    numSpaces () {
      this.$emit('update:spaces', this.numSpaces)
    }
  },
  computed: {
    ...mapGetters('identity', ['spacesIOwn', 'getPractitionerById']),
    spaces () {
      return this.spacesIOwn
    },
    numSpaces () {
      if (this.spaces) {
        return this.spaces.length
      }
      return 0
    },
    selectedSpaceId () {
      return this.getObjectPath(this.selectedSpace, 'id')
    },
    selectedPractitionerId () {
      return this.getObjectPath(this.selectedPractitioner, 'id')
    },
    members () {
      if (this.selectedSpace && this.selectedSpace.members) {
        return this.selectedSpace.members.map((practitionerId) => {
          return this.getPractitionerById(practitionerId)
        })
      }
      return []
      // if (this.selectedSpaceId) {
      //   return this.getMembers(this.selectedSpaceId)
      // }
      // return []
    }
  }
}
</script>
